import { useNavigate } from 'react-router-dom';
import { Sparkles, Lock, Check } from 'lucide-react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from '@/components/ui/dialog';

const PERKS = [
  '25 générations musicales',
  'Téléchargement de tes morceaux privés',
  'Partage & participation aux Challenges',
];

// Reusable paywall shown when a free/non-premium user hits a premium action.
export function Paywall({ open, onOpenChange, feature = 'Cette action' }) {
  const navigate = useNavigate();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="glass max-w-md" data-testid="paywall-dialog">
        <DialogHeader>
          <div className="mx-auto mb-2 flex h-14 w-14 items-center justify-center rounded-2xl bg-brand/15">
            <Lock className="h-7 w-7 text-brand" />
          </div>
          <DialogTitle className="text-center">Pack MyMusic IA requis</DialogTitle>
          <DialogDescription className="text-center">
            {feature} nécessite le Pack MyMusic IA. Débloque toutes les fonctionnalités premium.
          </DialogDescription>
        </DialogHeader>
        <div className="rounded-2xl border border-brand/40 bg-brand/5 p-5">
          <div className="flex items-baseline justify-between">
            <p className="font-display text-lg font-bold text-white">Pack 25 générations</p>
            <p className="font-display text-2xl font-extrabold text-brand">1 000 <span className="text-sm">FCFA</span></p>
          </div>
          <ul className="mt-4 space-y-2">
            {PERKS.map((p) => (
              <li key={p} className="flex items-center gap-2 text-sm text-white">
                <Check className="h-4 w-4 flex-shrink-0 text-brand" /> {p}
              </li>
            ))}
          </ul>
        </div>
        <button onClick={() => { onOpenChange(false); navigate('/credits'); }}
                data-testid="paywall-buy-button"
                className="flex w-full items-center justify-center gap-2 rounded-full bg-brand py-3 font-semibold text-black btn-glow">
          <Sparkles className="h-4 w-4" /> Acheter des crédits
        </button>
      </DialogContent>
    </Dialog>
  );
}
